var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1722 20.7531C19.1722 21.0755 19.4418 21.3 19.7361 21.3C20.0305 21.3 20.3 21.0755 20.3 20.7531C20.3 16.3683 17.0226 12.7164 12.6684 11.7909C14.9611 10.9713 16.6056 8.89006 16.6056 6.4321C16.6056 3.25041 13.8502 0.7 10.5 0.7C7.1498 0.7 4.39444 3.25041 4.39444 6.4321C4.39444 8.89006 6.03886 10.9713 8.33158 11.7909C3.97736 12.7164 0.7 16.3683 0.7 20.7531C0.7 21.0755 0.969529 21.3 1.26389 21.3C1.55825 21.3 1.82778 21.0755 1.82778 20.7531C1.82778 16.3101 5.70131 12.658 10.5 12.658C15.2987 12.658 19.1722 16.3101 19.1722 20.7531ZM5.52222 6.4321C5.52222 3.89527 7.73853 1.79383 10.5 1.79383C13.2615 1.79383 15.4778 3.89527 15.4778 6.4321C15.4778 8.96892 13.2615 11.0704 10.5 11.0704C7.73853 11.0704 5.52222 8.96892 5.52222 6.4321Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1257adffa5c7748897b7dc673a640695.svg";
export { ForwardRef as ReactComponent };